export const DAYS = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
export const DAY_KEYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export const EVENT_COLORS = [
  { bg: '#DBEAFE', text: '#1D4ED8', dot: '#3B82F6' },
  { bg: '#D1FAE5', text: '#065F46', dot: '#10B981' },
  { bg: '#FEF3C7', text: '#92400E', dot: '#F59E0B' },
  { bg: '#FCE7F3', text: '#9D174D', dot: '#EC4899' },
  { bg: '#EDE9FE', text: '#5B21B6', dot: '#8B5CF6' }
];

export const USER_EVENT_COLOR = {
  bg: '#E2E8F0',
  text: '#334155',
  dot: '#64748B'
};
